import React, { useState } from "react";
import { FaChevronLeft, FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import loginimg from "../../assets/images/Home/loginImage.jpg";
import { Card, Container, Row } from "react-bootstrap";
import logo from "../../assets/images/logo.png";
import axios from "axios";
import swal from "sweetalert";

const ForgotPassword = () => {
  const [mobile, setMobile] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const handleMobileChange = (e) => {
    const inputValue = e.target.value;
    if (/^\d{0,10}$/.test(inputValue)) {
      setMobile(inputValue);
    }
  };

  const handleVerifyMobile = async (e) => {
    e.preventDefault();

    if (!mobile) {
      swal("Error", "Please enter mobile number", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/mobile-verify`,
        { mobile }
      );

      if (response.data.success === "1") {
        // swal({
        //   title: "Success",
        //   text: "Mobile Number Verified!",
        //   icon: "success",
        //   timer: 2000,
        //   buttons: false,
        // });
        setIsVerified(true); // ✅ Show password fields
      } else if (response.data.success === "3") {
        swal({
          title: "Error",
          text: "Not Exists Or Inactive!",
          icon: "error",
          timer: 2000,
          buttons: false,
        });
      }
    } catch (error) {
      console.error(
        "Mobile Verify Error:",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };

  // ✅ Step 2: Update Password
  const handleUpdatePassword = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      swal("Error", "Please fill both password fields", "error");
      return;
    }

    if (newPassword !== confirmPassword) {
      swal("Error", "Passwords do not match", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/update-password`,
        {
          mobile,
          password: newPassword,
        }
      );

      if (response.data.success === "1") {
        swal({
          title: "Success",
          text: "Password updated successfully!",
          icon: "success",
          timer: 2000,
          buttons: false,
        });

        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        swal(
          "Error",
          response.data.message || "Something went wrong!",
          "error"
        );
      }
    } catch (error) {
      console.error(
        "Update Password Error:",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="form_page">
      <div className="page_header"></div>
      <Container>
        <Card className="p-2 py-md-4 px-md-5 my-3 my-md-5">
          <Row className="align-items-center">
            <div className="col-xl-6">
              <div className="form_block">
                <div className="text_block">
                  <Link
                    to="/"
                    className="educate_link_btn color-primary h6 mb-24"
                  >
                    <FaChevronLeft /> Back To Home
                  </Link>

                  <div className="title">
                    <div className="brandlogo text-center">
                      <img src={logo} alt="logo" style={{ width: "150px" }} />
                    </div>
                    <h4 className="mb-8 mt-2">Forgot Password</h4>
                    <p className="mb-12">Recover your password</p>
                  </div>

                  {/* ✅ Conditional Rendering */}
                  {!isVerified ? (
                    <form onSubmit={handleVerifyMobile} noValidate>
                      <label className="form-label">Mobile Number</label>
                      <div className="mb-24">
                        <input
                          type="text"
                          className="form-control p_lg"
                          placeholder="Enter Mobile Number"
                          value={mobile}
                          onChange={handleMobileChange}
                          required
                        />
                      </div>
                      <button
                        type="submit"
                        className="b-unstyle educate-btn w-100 mb-24"
                        disabled={loading}
                      >
                        <span className="educate-btn__curve"></span>
                        {loading ? "Verifying..." : "Verify Mobile"}
                      </button>
                    </form>
                  ) : (
                    <form onSubmit={handleUpdatePassword} noValidate>
                      {/* New Password */}
                      <div className="mb-24 position-relative">
                        <label className="form-label">New Password</label>
                        <input
                          type={showNewPassword ? "text" : "password"}
                          className="form-control p_lg"
                          placeholder="Enter New Password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          required
                        />
                        <span
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "38px",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowNewPassword(!showNewPassword)}
                        >
                          {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>

                      {/* Confirm Password */}
                      <div className="mb-24 position-relative">
                        <label className="form-label">Confirm Password</label>
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          className="form-control p_lg"
                          placeholder="Confirm Password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                        <span
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "38px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>

                      <button
                        type="submit"
                        className="b-unstyle educate-btn w-100 mb-24"
                        disabled={loading}
                      >
                        <span className="educate-btn__curve"></span>
                        {loading ? "Updating..." : "Update Password"}
                      </button>
                    </form>
                  )}

                  <div className="bottom-row justify-content-between">
                    <h6>
                      <Link to="/login" className="color-primary">
                        Login Now
                      </Link>
                    </h6>
                    <h6>
                      <Link to="/register" className="color-primary">
                        Enroll Now?
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            <img
              src={loginimg}
              alt="Login"
              className="rounded login_bg d-none d-md-block"
            />
          </Row>
        </Card>
      </Container>
    </section>
  );
};

export default ForgotPassword;
